import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  Grid,
  Typography,
  Button,
  CircularProgress,
} from '@material-ui/core';

import PolicyRegister from 'components/PolicyRegister';
import { RootState } from 'store';
import { setIsCreating } from 'modules/policy';

import { useStyles } from './styles';
import { isLoading } from 'utils/loading';

const PolicyList: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { loading: policyLoading, list } = useSelector(
    (state: RootState) => state.policyList,
  );
  const { isCreating } = useSelector((state: RootState) => state.policy);

  const { permissions, loading: userLoading } = useSelector(
    (state: RootState) => state.user,
  );

  const loading = isLoading([policyLoading, userLoading]);

  return (
    <Box p={1}>
      <Grid container direction="column">
        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={classes.header}
        >
          <Grid item>
            <Typography data-cy="settings-policies__label--title" variant="h4">
              Perfis
            </Typography>
          </Grid>
          <Grid item>
            {permissions['policy:create'] && (
              <Button
                data-cy="settings-policies__button--create-policy"
                variant="contained"
                color="primary"
                onClick={() => dispatch(setIsCreating(true))}
              >
                Criar novo Perfil
              </Button>
            )}
          </Grid>
        </Grid>
        <Grid item>
          {loading ? (
            <Box display="flex" justifyContent="center">
              <CircularProgress />
            </Box>
          ) : !permissions['policy:list'] ? (
            <Typography>
              Sem permissão para visualizar a listagem de Perfis.
            </Typography>
          ) : (
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignItems="stretch"
            >
              {isCreating && (
                <PolicyRegister
                  policy={{ _id: 'new', name: '', permissions: [] }}
                />
              )}

              {list.map((policy) => (
                <PolicyRegister key={policy._id} policy={policy} />
              ))}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default PolicyList;
